import React from "react";
import { Container } from "./Logo.styles";

import IconUizardMiroBlack from "cms/images/uizard-miro-labs-logo-black.svg";
import IconUizardMiroWhite from "cms/images/uizard-miro-labs-logo-white.svg";

import { useTheme } from "styled-components";

const ASSETS_MAP = {
  default: {
    light: IconUizardMiroBlack,
    dark: IconUizardMiroWhite,
  },
};

export interface LogoProps {
  size?: string;
}

const Logo: React.FC<LogoProps> = ({ size }) => {
  const theme = useTheme();
  // @ts-expect-error We know that we cover all theme modes
  const asset = ASSETS_MAP.default[theme.mode] as string;

  return <Container src={asset} alt="Uizard logo" $size={size} />;
};

export default Logo;
